<template>
  <div v-if="visible" class="modal-overlay modal-criar-exame">
    <div class="criar-exame-dialog">
      <div class="criar-exame-body">
        <div class="modal-header">
          <span class="modal-title">{{ $t('x_plus.create_exam') }}</span>
        </div>

        <div class="fonte-especialidade-row">
          <div class="fonte-especialidade-col">
            <label class="label-modal" for="xpCriarExameFonte">{{ $t('x_plus.source') }}</label>
            <select
              id="xpCriarExameFonte"
              v-model="selectedSource"
              class="form-control fonte-criar-exame"
              disabled
            >
              <option value="" disabled>{{ sourcePlaceholder }}</option>
              <option
                v-for="item in sourceOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>

          <div class="fonte-especialidade-col">
            <label class="label-modal" for="xpCriarExameEspecialidade">{{ $t('speciality') }}</label>
            <select
              id="xpCriarExameEspecialidade"
              v-model="selectedSpeciality"
              class="form-control especialidade-criar-exame"
              disabled
            >
              <option value="">{{ specialityPlaceholder }}</option>
              <option
                v-for="item in specialityOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>

        <div class="criar-exame-list">
          <div class="criar-exame-list-scroll">
            <label class="label-modal">{{ $t('x_plus.create_exam_select_file') }}</label>
            <div v-if="files.length" class="lista-anexos">
              <div v-for="(anexo, idx) in files" :key="anexo.name" class="item-anexo">
                <span class="anexo-nome">{{ anexo.name }}</span>
                <md-button class="btn-remover-anexo" @click="removeFile(idx)"> ❌ </md-button>
              </div>
            </div>
            <div v-else style="width: 100%; background-color: #f8f9fb; border-radius: 15px; margin-top: 12px;">
              <div class="placeholder-anexos-vazio">{{ $t('x_plus.no_attachments_selected') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer criar-exame-footer">
        <input ref="fileInput" type="file" multiple :accept="accept" style="display: none" @change="onFileChange" />
        <md-button v-if="files.length" class="md-raised btn-limpar-anexos" @click="limparAnexos">{{ $t('x_plus.clear_attachments') }}</md-button>
        <md-button v-tooltip="{ content: $t('x_plus.search_attachment') }" class="btn-anexar-arquivos" @click="triggerFileInput">
          <span class="material-icons">search</span>
        </md-button>
        <md-button class="md-raised" @click="emitClose">{{ $t('close') }}</md-button>
        <md-button style="color: #fff" class="btn-anexar-arquivos" :disabled="isSaveDisabled" @click="emitSave">
          {{ $t('x_plus.create_exam') }}
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { showDialog } from '@/shared/sweetAlerts/showDialog';
  import XPlusMixin from '@/shared/mixins/x-plus.mixin'

  export default {
    name: 'CriarExameModal',
    mixins: [XPlusMixin],
    props: {
      visible: { type: Boolean, required: true },
      accept: { type: String, default: '.pdf,.jpg,.jpeg' }
    },
    data() {
      return {
        files: [],
        selectedSource: '',
        selectedSpeciality: '',
        sourceOptions: [],
        specialityOptions: [],
        isLoadingSources: false,
        isLoadingSpecialities: false
      }
    },
    computed: {
      isSaveDisabled() {
        return !this.files.length || !this.selectedSource
      },
      sourcePlaceholder() {
        return this.isLoadingSources ? 'Carregando...' : 'Selecione...'
      },
      specialityPlaceholder() {
        return this.isLoadingSpecialities ? 'Carregando...' : 'Selecione'
      }
    },
    watch: {
      visible(isVisible) {
        if (isVisible) {
          this.files = []
          this.selectedSource = ''
          this.selectedSpeciality = ''
          this.loadSources()
          this.loadSpecialities()
        }
      }
    },
    methods: {
      loadSources() {
        const selectedSource = JSON.parse(localStorage.getItem('selectedSource') || 'null')
        if (selectedSource && selectedSource.id != null) {
          this.sourceOptions = [{ value: selectedSource.id, label: selectedSource.value || selectedSource.description || '' }]
          this.selectedSource = selectedSource.id
        } else {
          this.sourceOptions = []
          this.selectedSource = ''
        }
      },
      async loadSpecialities() {
        this.isLoadingSpecialities = true
        try {
          this.specialityOptions = await this.getCreateExamSpecialityList()
          if (this.specialityOptions.length) {
            this.selectedSpeciality = this.specialityOptions[0].value
          }
        } finally {
          this.isLoadingSpecialities = false
        }
      },
      triggerFileInput() {
        this.$refs.fileInput.click()
      },
      onFileChange(e) {
        const arquivos = Array.from(e.target.files)
        for (const arq of arquivos) {
          const isPDF = arq.type === 'application/pdf' && arq.name.toLowerCase().endsWith('.pdf')
          const isJPG = arq.type === 'image/jpeg' && (arq.name.toLowerCase().endsWith('.jpg') || arq.name.toLowerCase().endsWith('.jpeg'))
          if (!isPDF && !isJPG) {
            showDialog({
              icon: 'warning',
              title: 'Extensão inválida',
              text: 'Somente arquivos PDF ou JPG são permitidos.',
              confirmButtonText: 'OK'
            })
            continue
          }
          const duplicado = this.files.some(a => a.name === arq.name && a.size === arq.size)
          if (duplicado) {
            showDialog({
              icon: 'warning',
              title: this.$t('x_plus.dialog_message.warn'),
              text: this.$t('x_plus.dialog_message.file_already_in_list', { fileName: arq.name }),
              confirmButtonText: 'OK'
            })
            continue
          }
          this.files.push(arq)
        }
        e.target.value = ''
      },
      removeFile(idx) {
        this.files.splice(idx, 1)
      },
      limparAnexos() {
        showDialog({
          title: this.$t('x_plus.dialog_message.confirmation'),
          text: this.$t('x_plus.dialog_message.confirm_clear_attachments'),
          confirmButtonText: this.$t('x_plus.yes'),
          denyButtonText: this.$t('x_plus.no'),
          icon: 'question',
          focusConfirm: false,
          focusDeny: true,
          confirmed: () => { this.files = [] }
        })
      },
      emitSave() {
        this.$emit('save', { files: this.files, sourceID: this.selectedSource, specialityID: this.selectedSpeciality })
      },
      emitClose() {
        this.files = []
        this.selectedSource = ''
        this.selectedSpeciality = ''
        this.$emit('close')
      }
    }
  }
</script>
